import { render, staticRenderFns } from "./ClickToEdit.vue?vue&type=template&id=ba58d722&scoped=true"
import script from "./ClickToEdit.vue?vue&type=script&lang=js"
export * from "./ClickToEdit.vue?vue&type=script&lang=js"
import style0 from "./ClickToEdit.vue?vue&type=style&index=0&id=ba58d722&prod&scoped=true&lang=scss"
import style1 from "./ClickToEdit.vue?vue&type=style&index=1&id=ba58d722&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba58d722",
  null
  
)

export default component.exports